import { get, postAPI } from "../ApiService";
import Swal from "sweetalert2";
export const getSingleProjectReport = async() => {
    let res = await get('/reports/get-project/single/')
    return res;
}
export const getAllProjectReport = async(gProjectID = null, startDate = null, endDate = null) => {
    let qs = [];
    if(gProjectID !== null && !isNaN(gProjectID))
        qs.push('projectID=' + gProjectID);
    if(startDate)
        qs.push('startDate=' + startDate);
    if(endDate)
        qs.push('endDate=' + endDate);
    let res = await get('/reports/get-project/all/' + (qs.length > 0 ? '?' + qs.join('&') : ''))
    return res;
}
export const getGroupProjectReport = async() => {
    let res = await get('/reports/get-project/group/')
    return res;
}
export const getClientList = async() => {
    let res = await get('/reports/get-client/')
    return res;
}

export const getSupplierList = async() => {
    let res = await get('/reports/get-supplier/')
    return res;
}

export const viewProjectReport = async({payload}) => {
    let res = await postAPI('/reports/project/view/', payload)
    return res;
}

export const exportSupplierProjectReport = async({payload}) => {
    return Swal.fire({
        text:'Loading...',
        timer: 1500,
        showConfirmButton:false
    }).then(async () => {
        let res = await postAPI('/reports/download/supplier/project/', payload)
        if(res.status === 1){
            return Swal.fire({
                text:res.message,
                timer: 1500,
            }).then(() => {
                return res;
            });
        }
    })
}